<template>
  <div>
    <UserCtas :hide-user-cta="hideUserCta" @face-checkin-cta="$emit('face-checkin-cta')"/>

    <MediaTabs @select="currentTab = $event"/>

    <div>
      <UnlockedGalleries v-show="currentTab===checkinTabs.BOUGHT"
                         :galleries="unlockedGalleries"
                         v-if="unlockedGalleries && unlockedGalleries.length > 0"/>

      <PaidGalleries v-show="currentTab===checkinTabs.BUYABLE"
                     :galleries="paidGalleries"
                     v-if="paidGalleries && paidGalleries.length > 0"/>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import UnlockedGalleries from "@/domain/galleries/UnlockedGalleries.vue";
import {checkinTabs} from "@/domain/galleries/constants";
import PaidGalleries from "@/domain/galleries/PaidGalleries.vue";
import MediaTabs from "@/domain/galleries/components/MediaTabs.vue";
import UserCtas from "@/domain/galleries/components/UserCtas.vue";

export default {
  name: 'Galleries',
  emits: ['face-checkin-cta'],
  data() {
    return {
      currentTab: checkinTabs.BOUGHT
    }
  },
  components: {
    UserCtas,
    MediaTabs,
    PaidGalleries,
    UnlockedGalleries,
  },
  props: {
    hideUserCta: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('checkinDetail', ['checkin']),
    ...mapGetters('galleries', [
      'galleries',
      'unlockedGalleries',
      'paidGalleries',
    ]),
    checkinTabs() {
      return checkinTabs
    }
  },
  async mounted() {
    this.resetGalleries()
    await this.load()
  },
  methods: {
    ...mapActions('galleries', [
      'fetchGalleries',
      'resetGalleries']),
    async load() {
      await this.fetchGalleries({
        checkin_id: this.checkin.checkin_id
      })
    }
  },
  beforeDestroy() {
    this.resetGalleries()
  }
}
</script>

